<template>
  <div class="cross-profile-box">
    <el-tooltip :disabled="disabled" :content="tooltip">
      <div :class="`square square-color-tier-${roundedPercentage}`">
        <span class="square-text">{{ roundedPercentage }}</span>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
import { capitalize, get, round } from 'lodash';

export default {
  name: 'CrossPlatformEngagementCellBlock',
  computed: {
    disabled() {
      return this.roundedPercentage === 0 || isNaN(this.roundedPercentage);
    },
    roundedPercentage() {
      return round(parseFloat(this.percentage));
    },
    tooltip() {
      const firstName = this.format(this.first_platform);
      const secondName = this.format(this.second_platform);
      return `${this.roundedPercentage}% of your audience engaged on both ${firstName} and ${secondName}`;
    },
  },
  props: {
    first_platform: {
      type: String,
      required: '',
    },
    second_platform: {
      type: String,
      required: '',
    },
    percentage: {
      type: Number,
      default: 0,
    },
    isCross: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    format(platform) {
      const cleanNames = {
        sms: 'SMS',
        whatsapp: 'WhatsApp',
      };
      return get(cleanNames, platform, capitalize(platform));
    },
  },
};
</script>
<style lang="scss">
$default-square-color: #00008b;

@mixin square-color-list {
  @for $i from 0 through 100 {
    .square-color-tier-#{$i} {
      background: rgba($default-square-color, $i / 15);
    }
  }
}

@include square-color-list;

.cross-profile-box {
  margin: 0px;
}

$square-color: #555;

.square {
  display: inline-block;
  height: 30px;
  width: 30px;
  transition: 0.5s all ease-in;
  color: transparent;
  text-align: center;
  border: 2px solid transparent;
  border-radius: 5px;
  &:hover {
    color: #fff;
  }
  .square-text {
    display: inline-block;
    margin: 1px;
  }

  i {
    padding-top: 4px;
  }

  .cross {
    font-size: 20px;
    color: #eee;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// CrossPlatformEngagementCellBlock.vue?11d0def1